export const SHOW_MOVIE_DETAILS = 'SHOW_MOVIE_DETAILS';
export const MOVIE_DETAILS_FAIL = 'SHOW_MOVIE_DETAILS';
